var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 36,
    viewBox: "16.5 10 23 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9978 10.1819V23.352L39.4473 28.3261L27.9978 10.1819Z",
    fill: "black",
    fillOpacity: 0.602
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9969 10.1819L16.5459 28.3261L27.9969 23.352V10.1819Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9978 36.861V45.8099L39.455 30.3992L27.9978 36.861Z",
    fill: "black",
    fillOpacity: 0.602
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9969 45.8099V36.8595L16.5459 30.3992L27.9969 45.8099Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9978 34.7899L39.4473 28.3266L27.9978 23.3555V34.7899Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5459 28.3266L27.9969 34.7899V23.3555L16.5459 28.3266Z",
    fill: "black",
    fillOpacity: 0.602
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.d80adb4c.svg";
export { ForwardRef as ReactComponent };